import localizeFilter from '../filters/localize.filter';

export function localeNumber(num, locale) {   
  if (locale == 'ro-RO') {
    return num.toLocaleString('en-US')
  }
  return num.toLocaleString(locale)
}

export function PromoCodeGenerator(num) {
    const dictionary =
      '1234567890qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHKLZXCVBNM';
    let res = '';
    for (let index = 0; index < num; index++) {
      res += dictionary[Math.floor(Math.random() * (dictionary.length - 1))];
    }
    return res;
}

export function ConvertDateToString(date, locale) {
  return date.toLocaleString(locale, { timeZone: 'UTC' }).substr(0, 10);
}

export function GetGameId(str) { 
  const num = str.replace(/[^0-9]/g, ''); 
  return parseInt(num, 10); 
}

export function getMonth (month) {
	let mon = '';
	switch (month) {
		case 2: mon = localizeFilter('February'); break;
		case 3: mon = localizeFilter('March'); break;
		case 4: mon = localizeFilter('April'); break;
		case 5: mon = localizeFilter('May'); break;
		case 6: mon = localizeFilter('June'); break;
		case 7: mon = localizeFilter('July'); break;
		case 8: mon = localizeFilter('August'); break;
		case 9: mon = localizeFilter('September'); break;
		case 10: mon = localizeFilter('October'); break;
		case 11: mon = localizeFilter('November'); break;
		case 12: mon = localizeFilter('December'); break;
		default: mon = localizeFilter('January'); 
	}
	return mon;
}

export function serializing(arr) {
	let res = ''
	if (arr && arr.length) {
		/* return arr.join(', '); */
		for(let i=0; i < arr.length - 1; i++) {
			res+= localizeFilter(`${arr[i]}`) + ', '
		}
		res+= localizeFilter(`${arr[arr.length - 1]}`)
	}
	return res
}

export function roundNumber(num, decimalPlaces = 0) {
  const p = Math.pow(10, decimalPlaces);
  const n = num * p * (1 + Number.EPSILON);
  return Math.round(n) / p;
}

export function convertToNumber(str) {
    const numbersOnly = str.replace(/[^0-9]/g, '');
    return parseInt(numbersOnly);
}

